import { gql } from 'apollo-angular';
import { DocumentNode } from 'graphql';

export const getLoadTypeDefaults: DocumentNode = gql`
  query loadTypeDefaults {
    loadTypeDefaults(orderBy: description_ASC) {
      id
      description
      liveLoad
      deadLoad
      serviceLoad
      beamDeflection
      joistDeflection
      minimumJoistThickness
      centres
      deckingSection {
        id
      }
    }
  }
`;
